import { lazyMsg } from '~/common/localizationUtils'

const userRoles = {
  Employer: 'employer',
  Vendor: 'vendor',
  All: 'ALL'
}

export const getBusinessUnitFilter = () => ({
  id: 'business_unit',
  allowedFor: [userRoles.Employer],
  type: 'bu',
  title: lazyMsg('term.business_unit', { count: 1 })
})

export const dateRange = {
  id: 'date_range',
  allowedFor: [userRoles.All],
  type: 'date_range',
  title: lazyMsg('common.ui.date_range')
}

export const invoiceStatus = {
  id: 'invoice_status',
  allowedFor: [userRoles.All],
  type: 'list',
  listType: 'number',
  options: [
    { id: 'not_started', text: lazyMsg('invoice_constants.not_started'), value: '0' },
    { id: 'in_process', text: lazyMsg('invoice_constants.in_process'), value: '1' },
    { id: 'approved', text: lazyMsg('common.ui.approved'), value: '2' },
    { id: 'invoiced', text: lazyMsg('term.invoiced'), value: '7' },
    { id: 'hold', text: lazyMsg('term.hold'), value: '8' },
    { id: 'paid_closed', text: lazyMsg('dashboards.invoice_status_filter.paid_closed'), value: '9' },
    { id: 'paid_partially', text: lazyMsg('dashboards.invoice_status_filter.paid_partially'), value: '10' },
    { id: 'voided', text: lazyMsg('common.ui.voided'), value: '12' },
    { id: 'void_credit', text: lazyMsg('common.ui.void_credit'), value: '13' }
  ],
  title: lazyMsg('common.ui.status', { count: 1 })
}

export const contractorStatus = {
  id: 'contractor_status',
  allowedFor: [userRoles.All],
  type: 'list',
  title: lazyMsg('common.ui.status', { count: 1 }),
  options: [
    { id: 'pending', text: lazyMsg('term.pending'), value: '1' },
    { id: 'active', text: lazyMsg('term.active'), value: '2' },
    { id: 'ended', text: lazyMsg('term.ended'), value: '3' }
  ]
}

export const jobStatus = {
  id: 'job_status',
  allowedFor: ['All'],
  type: 'list',
  title: lazyMsg('common.ui.status', { count: 1 }),
  options: [
    { id: 'draft', text: lazyMsg('term.draft'), value: '1' },
    { id: 'pending_approval', text: lazyMsg('common.ui.pending_approval'), value: '2' },
    { id: 'hold', text: lazyMsg('term.hold'), value: '3' },
    { id: 'active', text: lazyMsg('term.active'), value: '4' },
    { id: 'closed', text: lazyMsg('common.ui.closed'), value: '5' },
    { id: 'pending_vendor', text: lazyMsg('job_status.is_pending.vendor_assignment'), value: '6' },
    { id: 'pending_connector', text: lazyMsg('job_status.is_pending.connector'), value: '7' }
  ]
}

export const jobCategory = {
  id: 'job_category',
  allowedFor: ['All'],
  type: 'list',
  config: { maxCheckableCount: 100 },
  optionsFromApi: {
    pageSize: 100,
    searchParamKey: 'name',
    transform: "results.{'id':id, 'text':name, 'value':name}[]",
    url: '/api/v2/jobs/categories'
  },
  title: lazyMsg('common.category')
}

export const jobTitle = {
  id: 'job_title',
  allowedFor: ['All'],
  type: 'list',
  config: { maxCheckableCount: 100 },
  optionsFromApi: {
    pageSize: 100,
    searchParamKey: 'title',
    transform: "results.{'id': id, 'text':title, 'value': title}[]",
    url: '/api/v2/job_titles/titles'
  },
  title: lazyMsg('common.ui.title')
}

export const jobModule = {
  id: 'module',
  allowedFor: ['All'],
  type: 'list',
  title: lazyMsg('term.module'),
  options: [
    { id: 'contigent', text: lazyMsg('dashboards.job_module_filter.contigent'), value: '0' },
    { id: 'sow', text: lazyMsg('dashboards.job_module_filter.sow'), value: '1' },
    { id: 'wpm', text: lazyMsg('dashboards.job_module_filter.wpm'), value: '2' }
  ]
}

export const resourceManagerFilter = {
  id: 'rm',
  allowedFor: [userRoles.All],
  type: 'list',
  config: { maxCheckableCount: 100, isVirtualized: true },
  optionsFromApi: {
    url: '/api/v2/employer_manager?type=rm&include_inactive=false',
    pageSize: 100,
    searchParamKey: 'name',
    transform: "results.{'id':id, 'text':full_name, 'value':id.$string()}[]"
  },
  title: lazyMsg('term.resource_manager', { count: 1 })
}

export const programTeamEntityFilter = {
  id: 'program_team_entity',
  allowedFor: [userRoles.All],
  type: 'list',
  listType: 'number',
  defaultIsOpen: false,
  config: { maxCheckableCount: 100, isVirtualized: true, containerMaxHeight: 600 },
  optionsFromApi: {
    pageSize: 100,
    searchParamKey: 'search',
    url: '/api/v2/program-team/select/?for_context=job_create',
    transform: "results.{'text':name, 'value':id}[]"
  },
  title: lazyMsg('term.program_team_entity')
}
